export const COOKIE_TO_IKEAAPP = 'ikeaapp-to-app'; // cookie created by boka
export const COOKIE_FROM_IKEAAPP = 'ikeaapp-from-app'; // cookie created by app team

type nativeAppCookieType = {
  [key: string]: string;
  accessToken: string;
};

// Set cookie with optional expiration date
export const setCookie = (name: string, obj: object, hours?: number): void => {
  let expires = '';
  if (hours) {
    const date: Date = new Date();
    date.setHours(date.getHours() + hours);
    expires = `; expires=${date.toUTCString()}`;
  }

  const encodedValue = btoa(JSON.stringify(obj)) || '';
  window.document.cookie = `${name}=${encodedValue}${expires}; path=/`;
};

export const getRawCookie = (cookieName: string): string => {
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookiesArray = decodedCookie.split(';');

  const foundCookie = cookiesArray.find((cookie) =>
    cookie.trim().startsWith(name),
  );

  return foundCookie ? foundCookie.trim().substring(name.length) : '';
};

export const getCookieAsObject = (cookieName: string): nativeAppCookieType => {
  const foundCookie = getRawCookie(cookieName);
  return foundCookie ? JSON.parse(atob(foundCookie)) : {};
};

export const getNativeAccessToken = (): string => {
  const nativeAppCookieObject = getCookieAsObject(COOKIE_FROM_IKEAAPP);
  return nativeAppCookieObject.accessToken || '';
};
